// W14 — THE BUBBLE-READING CATEGORY ICONS, moved out of App.tsx under R37's currency (move the data,
// not the component) to pay for the navigation round's own lines.
//
// The mockup's per-category line icons, in their gold rings. Keyed by the config's `icon`, so the
// owner can move a category to a different icon with a JSON edit.
//
// It lives beside `rooms.tsx` because it is the same kind of thing: committed frontend data whose
// only non-plain part is a lucide JSX icon, which `loadTsx` stubs — so a gate can load and read this
// table for the first time. Measured before the move (R9's lesson, which has bitten five times): no
// script read `READING_ICONS` as source text, and nothing outside App.tsx referenced it.
import type { ReactNode } from "react";
import { Coins, Compass, Eye, Heart, Star, TriangleAlert, Waypoints } from "lucide-react";

export const READING_ICONS: Record<string, ReactNode> = {
  heart: <Heart size={30} strokeWidth={1.25} />,
  coins: <Coins size={30} strokeWidth={1.25} />,
  compass: <Compass size={30} strokeWidth={1.25} />,
  eye: <Eye size={30} strokeWidth={1.25} />,
  alert: <TriangleAlert size={30} strokeWidth={1.25} />,
  path: <Waypoints size={30} strokeWidth={1.25} />,
  star: <Star size={30} strokeWidth={1.25} />,
};
